<template>
  <div>
    <decision-branch-category :branchId="branchId" :cardId="cardId" @close="close()" @navigateModal="navigateModal" :prevBranchId="prevBranchNavIds[prevBranchNavIds.length - 1]">
      <template v-slot:modal-title>
        {{ branchDisplayName }}
      </template>
    </decision-branch-category>
  </div>
</template>
<script>
import DecisionBranchModalMixin from "@/components/homepage/mixins/DecisionBranchModalMixin";
import DecisionBranchCategory from "@/components/homepage/DecisionBranchCategory";
export default {
  mixins: [DecisionBranchModalMixin],
  components: {
    DecisionBranchCategory,
  },
  data() {
    return { 
      branchId: null,
      prevBranchNavIds: []
      };
  },
  created(){
    this.branchId =  this.decisionBranchesByCurrentCardId.filter(
          (item) => !item.category
        )[0].id;
    this.updatePrevNavIds()
  },
  methods:{
     close() {
       this.$router.push("/").catch(()=>{});
       this.$emit("close")
    },
     navigateModal(branchId, backNavClicked = false) {
       if(backNavClicked) {
         this.branchId = this.prevBranchNavIds.pop()
       } else {
         this.updatePrevNavIds()
         this.branchId = branchId;
       }
    },
    updatePrevNavIds() {
      if(this.currentBranchContainsNestedBranch()) {
        this.prevBranchNavIds.push(this.branchId)
      }
    }
  }
};
</script>
<style scoped>
.modal-container {
  min-height: 500px;
  background: #ffffff;
}
.header-container {
  font-family: artifaktElementBold;
}

.modal-container-body {
  background-color: #fff;
  padding: 0px 30px 30px 20px;
}
.branch-description {
  font-size: 16px;
  font-family: artifaktElementRegular !important;
}


</style>
